<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="loginLogo clearfix">
        <i></i>
        <h2>排水户管理系统</h2>
      </div>
      <p class="loginStyle" v-text="loginWayTip"></p>
      <!-- 账号密码登录 -->
      <div class="loginAccount" v-if="loginWay === 'account'">
        <ul>
          <li>
            <input type="text" placeholder="用户名" v-model="userName">
          </li>
          <li class="mt-20">
            <input type="password" placeholder="密码" v-model="password">
          </li>
        </ul>
        <button id="loginBtn" v-on:click="onUserLogin">登录</button>
        <!-- <a href="#" class="forgetPass" @click="loginWay = 'fogetPass'">忘记密码？</a> -->
      </div>
      <!-- 二维码登录 -->
      <div class="loginWechat" v-if="loginWay === 'wechat'">
        <img id="ewPhoto" src="" alt="">
        <!-- 刷新二维码 -->
        <div class="refresh" v-show="refreshIsShow">
          <div @click="refreshQRCode">
            <b class="el-icon-refresh "></b>
          </div>
        </div>
        <span>{{tip}}</span>

      </div>
      <!-- 忘记密码 -->
      <div class="loginForgetPass" v-if="loginWay === 'fogetPass'">
        <ul>
          <li class="clearfix">
            <input type="text" placeholder="手机号" v-model="phoneNum" @input="phoneIsDisable">
            <button :class="{enable:isPhone ,able:!isPhone}" :disabled='isPhone' @click="sendYZM">{{CountDownText}}
            </button>
          </li>
          <li class="mt-20">
            <input class="jsyzm" type="text" placeholder="手机接收验证码">
          </li>
        </ul>
        <button @click="loginWay = 'updatePass'">下一步</button>
        <p @click="loginWay = 'account'">登录</p>
      </div>
      <!-- 更新密码 -->
      <div class="loginUpdatePass" v-if="loginWay === 'updatePass'">
        <p class="tip">密码应包含字母及数字长度8-16位</p>
        <ul>
          <li>
            <input type="password" placeholder="密码" >
          </li>
          <li class="mt-20">
            <input type="password" placeholder="重复密码" >
          </li>
        </ul>
        <button >更新密码</button>
        <p @click="loginWay = 'account'">登录</p>
      </div>
      <!-- 登录方式切换 -->
      <div class="loginWayChange" v-if="loginWay != 'fogetPass'">
        <div class="tip" v-if="loginWay != 'updatePass'">
          <i></i>
          <span v-text="loginWayTip_01"></span>
        </div>
        <div class="pic">
          <img src="./weichart.png" alt="" v-if="loginWay === 'account'" @click="loginWay = 'wechat'" v-on:click="refreshQRCode">
          <img src="./username@1x.png" alt="" v-if="loginWay === 'wechat'" @click="loginWay = 'account'">
        </div>
      </div>
    </div>
    <div class="Copyright" style="display: none">
      <p>Copyright © 北京清控人居环境研究院有限公司</p>
      <p>京ICP备14018853号-2</p>
    </div>
  </div>
</template>

<script>
// 引入加密第三方库（ npm install --save jsencrypt）
import { JSEncrypt } from 'jsencrypt'
export default {
  name: 'Login',
  data() {
    return {
      loginWay: 'wechat',
      userName: '',
      password: '',
      loginWayA: '用户名密码登录',
      refreshIsShow: false,// 刷新二维码是否显示
      isPhone: true,//发送验证码
      phoneNum: '', //手机号
      CountDownText: '发送验证码',
      ticket:"",
      tip:"请使用微信扫码登录",
      systemId: this.subsystemId
    }
  },
  computed: {
    loginWayTip() {
      let loginWayTip = ''
      if (this.loginWay === 'account') {
        loginWayTip = '用户名密码登录'
      } else if (this.loginWay === "wechat") {
        loginWayTip = '微信扫码登录'
      } else if (this.loginWay === "fogetPass") {
        loginWayTip = '忘记密码'
      } else if (this.loginWay === "updatePass") {
        loginWayTip = '更新密码'
      }
      return loginWayTip
    },
    loginWayTip_01() {
      let loginWayTip_01 = ''
      if (this.loginWay === 'wechat') {
        loginWayTip_01 = '用户名密码登录'
      } else if (this.loginWay === "account") {
        loginWayTip_01 = '微信扫码登录'
      }
      return loginWayTip_01
    }
  },
  created: function() {
  },
  mounted() {
    var v = this;
    // var keyJson = v.$route.params.key;
    var keyJson = v.$route.query.key;
    // 判断是否从大平台跳转登录过来？(key=local时为本地登录，反之则为大平台跳转过来)
    if (v.isNeedLogin && (keyJson!='' && typeof(keyJson)!="undefined") && keyJson!='local') {
      this.$router.push({name:'systemTurn',params:{'keyJson': keyJson}});
    }else {
      v.GetEwcode();
    }    
  },
  methods: { 
    phoneIsDisable() {
      var v = this;
      var Phone = /^[1][3,4,5,7,8][0-9]{9}$/;
      // console.log(Phone.test(v.phoneNum))
      if (Phone.test(v.phoneNum)) {
        v.isPhone = false
      } else {
        v.isPhone = true
      }
    },
    sendYZM() {
      var v = this;
      let time = 60;
      this.isPhone = true
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        time--
        v.CountDownText = time + '秒后获取'
        if (time < 0) {
          v.isPhone = false
          v.CountDownText = '发送验证码'
          clearInterval(v.timer);
        }
      }, 1000);

    },
    refreshQRCode: function() {
      this.GetEwcode();
    },
    /**
     * 获取key
     * @param  {[type]} callBack [description]
     * @return {[type]}          [description]
     */
    getPublicKey(callBack) {
      var v = this;
      $.ajax({
        type: 'get',
        url: v.userApi + "api/Account/GetPublicKey",
        dataType: "json",
        headers: {
        },
        success: function (des) {
            if (des && des!='') {
              callBack(des);
            }else {
              alert("系统异常")
            }
        },
        error: function (des) {
            alert("系统异常")
        }
      })
    },
    onUserLogin:function()
    {
      var v=this;
      if(v.userName=="")
      {
        alert("请填写用户名")
        return;
      }
      if(v.password=="")
      {
        alert("请填写密码")
        return;
      }
      v.getPublicKey(function(key){
        var dd = v.encryptRequest({"username":v.userName,"password":v.password,"systemId":v.systemId}, key);
        $.ajax({
            type: 'POST',
            url: v.userApi + "api/Account/SystemUserLogin",
            contentType: "application/json",
            data: dd,
            headers: {
                // "Authorization": localStorage.getItem('tk')
            },
            success: function (des) {
              // 重置sessionStorage数据
              sessionStorage.clear();

              var data = JSON.parse(des);
              sessionStorage.setItem('drainage-userInfo', data.userInfo);
              sessionStorage.setItem('drainage-companyInfo', data.companyInfo);
              sessionStorage.setItem('drainage-groupInfo', data.groupInfo);
              sessionStorage.setItem('drainage-moduleInfo', data.moduleInfo);
              v.$router.push({
                name: 'Message'
              });
            },
            error: function (des) {
              alert("用户名或密码错误")
            }
        })
      });
    },
    /**
     * 加密
     * @param  {[type]} data [description]
     * @param  {[type]} key  [description]
     * @return {[type]}      [description]
     */
    encryptRequest(data,key) {
      var encrypt = new JSEncrypt();
      var publicKey = key;
      encrypt.setPublicKey(publicKey)
      var sendData = new Object();
      for (var key in data) {
        sendData[key] = encrypt.encrypt(data[key]);
      }
      return JSON.stringify(sendData);
    },
    GetEwcode:function() {
      var v=this;
      $.ajax({
          type:'get',
          url: v.wechatApi+"api/Account/GetQrcodeTicketBySceneId",
          data:{sceneStr:'101203'},
          dataType:'json',
          success:function(data){
             v.ticket=data;
             v.imgSrc="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket="+data;
             //document.getElementById("ewPhoto").src=url;
             $("#ewPhoto").attr("src",v.imgSrc);
             v.tip = '请使用微信扫码登录';
             v.refreshIsShow = false;
             v.connectCount=0;
             v.erweimaLogin();
          },
          error: function(err) {
              alert("用户名或密码不正确。")
          }
      })
    },
    erweimaLogin:function()
    {
      var v=this;
      if(v.connectCount==3)
      {
        v.tip="二维码已失效，请重新获取"
        v.refreshIsShow = true;
        return;
      }
      $.ajax({
          type:'get',
          url: v.userApi+"api/Account/SystemUserQrcodeLogin?ticket="+v.ticket+"&sceneid=1012",
          dataType:'json',
          success:function(des){
            // 重置sessionStorage数据
            sessionStorage.clear();

            var data = JSON.parse(des);
            sessionStorage.setItem('drainage-userInfo', data.userInfo);
            sessionStorage.setItem('drainage-companyInfo', data.companyInfo);
            sessionStorage.setItem('drainage-groupInfo', data.groupInfo);
            sessionStorage.setItem('drainage-moduleInfo', data.moduleInfo);
            v.$router.push({
              name: 'Message'
            });
          },
          error: function(err) {
            if (err.status==404) {
              v.connectCount++;
              v.erweimaLogin();
            }
          }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .login-wrapper {
    position: absolute
    width: 100%
    height: 100%
    background-color: #fff
    background: url('./login-bg.jpg') no-repeat center center;
    background-size: 100% 100%;
    box-sizing: border-box;

    .login-container {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 416px;
      min-height: 518px;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 50px 50px 30px 50px;
      box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.20);
      border-radius: 4px;
      box-sizing: border-box;
      margin-bottom: 50px;
      /*logo*/

      .loginLogo {
        margin-bottom: 30px;
        display flex

        & > i {

          width: 46px;
          height: 46px;
          background: url('./logo1.png') no-repeat center center;
          background-size: 100% 100%;
        }
        &>h2 {
          flex: 1;
          margin-left: 20px;
          font-size: 30px;
          color: #3d3d3d;
          letter-spacing: 0;
          line-height: 52px;
          font-weight: 600;
        }
      }

      /*登录方式文字提醒*/

      .loginStyle {
        font-size: 16px;
        color: #5A6388;
        line-height: 22px;
        text-align: center;
      }

      /*账号密码登录*/

      .loginAccount {
        width: 260px;
        margin: 30px auto;
        position: relative;

        & > ul {
          & > li {
            width: 100%;
            text-align: center;

            & > input {
              border: 1px solid #E0E0E0;
              box-sizing: border-box;
              width: 100%;
              height: 45px;
              padding-left: 40px;
              font-size: 14px;
              color: #212121;
              letter-spacing: 0;
              background-size: 20px 20px;
            }

            .error {
              border: 1px solid #FF6D6D;
            }

            &:first-child {
              & > input {
                background: url('./username-n@1x.png') no-repeat 12px center;
              }
            }

            &:last-child {
              & > input {
                background: url('./key-n@1x.png') no-repeat 12px center;
              }
            }
          }
        }

        & > button {
          width: 100%;
          height: 45px;
          margin-top: 35px;
          background: #4D87F4;
          box-shadow: 0 4px 8px 0 rgba(74, 144, 226, 0.20);
          font-size: 14px;
          color: #FFFFFF;
          cursor: pointer;
        }

        .forgetPass {
          font-size: 14px;
          color: #5A6388;
          line-height: 22px;
          margin: 16px 0 28px;
          display: block;
          text-align: center;
          width: 100%;
          cursor: pointer;
        }
      }

      /*微信扫码登录*/

      .loginWechat {
        width: 180px;
        height: 228px;
        margin: 30px auto;
        text-align: center;
        position: relative;

        & > img {
          width: 100%;
          height: 180px
        }

        & > span {
          font-size: 14px;
          color: #393C40;
          letter-spacing: 0;
        }

        .refresh {
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(255, 255, 255, .8);
          background-size: 32px 32px;
          width: 180px;
          height: 180px;

          & > div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background-color: #fff;

            & > b {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
              color: #4285F4;
              font-size 20px;
            }
          }
        }
      }

      /*忘记密码*/

      .loginForgetPass {
        width: 260px;
        margin: 60px auto;
        position: relative;

        & > ul {
          & > li {
            width: 100%;
            text-align: center;

            & > input {
              border: 1px solid #E0E0E0;
              box-sizing: border-box;
              width: 100%;
              height: 45px;
              padding-left: 40px;
              font-size: 14px;
              color: #212121;
              letter-spacing: 0;
              letter-spacing: 0;
              background-size: 20px 20px;
            }

            .jsyzm {
              // background: url('../img/num-n@1x.png') no-repeat 12px center;
              background: url('./phone-n@1x.png') no-repeat 12px center;
            }

            .error {
              border: 1px solid #FF6D6D;
            }

            &:first-child {
              & > input {
                width: 157px;
                float: left;
                background: url('./phone-n@1x.png') no-repeat 12px center;
              }

              & > button {
                width: 92px;
                float: right;
                height: 45px;
                font-size: 15px;
                color: #FFFFFF;
                letter-spacing: 0;
                cursor: pointer;

                &.enable {
                  background: #E0E0E0;
                }

                &.able {
                  background: #4285F4;
                }
              }
            }
          }
        }

        & > button {
          width: 100%;
          height: 45px;
          margin-top: 35px;
          background: #4D87F4;
          box-shadow: 0 4px 8px 0 rgba(74, 144, 226, 0.20);
          font-size: 14px;
          color: #FFFFFF;
          cursor: pointer;
        }

        & > p {
          font-size: 14px;
          color: #5A6388;
          line-height: 22px;
          text-align: center;
          margin-top: 55px;
          cursor: pointer;
        }
      }

      /*更新密码*/

      .loginUpdatePass {
        width: 260px;
        margin: 30px auto;
        position: relative;

        .tip {
          font-size: 12px;
          color: rgba(33, 33, 33, 0.80);
          line-height: 18px;
          margin-bottom: 12px;
          text-align: left;
        }

        & > ul {
          & > li {
            width: 100%;
            text-align: center;

            & > input {
              border: 1px solid #E0E0E0;
              box-sizing: border-box;
              width: 100%;
              height: 45px;
              padding-left: 40px;
              font-size: 14px;
              color: #212121;
              letter-spacing: 0;
              letter-spacing: 0;
              background: url('./key-n@1x.png') no-repeat 12px center;
              background-size: 20px 20px;
            }

            .error {
              border: 1px solid #FF6D6D;
            }
          }
        }

        & > button {
          width: 100%;
          height: 45px;
          margin-top: 35px;
          background: #4D87F4;
          box-shadow: 0 4px 8px 0 rgba(74, 144, 226, 0.20);
          font-size: 14px;
          color: #FFFFFF;
          cursor: pointer;
        }

        & > p {
          font-size: 14px;
          color: #5A6388;
          line-height: 22px;
          text-align: center;
          margin-top: 55px;
          cursor: pointer;
        }
      }

      /*登录方式切换*/

      .loginWayChange {
        .tip {
          position: relative;
          text-align: center;
          margin-bottom: 23px;

          & > i {
            position: absolute;
            display: inline-block;
            width: 260px;
            height: 1px;
            background: #DEDFE1;
            left: 50%;
            transform: translateX(-50%);
            top: 11px;
            z-index: -5;
          }

          & > span {
            font-size: 14px;
            color: #7D8694;
            letter-spacing: 0;
            font-style: normal;
            text-align: center;
            background-color: #fff;
            padding: 0 15px;
          }
        }

        .pic {
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .Copyright {
      position: absolute;
      bottom: 30px;
      left: 50%;
      width: 434px;
      transform: translateX(-50%);
      text-align: center;
      color: #fff;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue